import ReactModalAdapter from "helpers/ReactModalAdapter.js";
import { ReactComponent as CloseIcon } from "feather-icons/dist/icons/x.svg";
import tw from 'twin.macro';
import styled from "styled-components";
import logo from "images/lra_pink.svg";

const StyledModal = styled(ReactModalAdapter)`
  &__overlay {
    ${tw`fixed inset-0 z-50 bg-black bg-opacity-75`}
  }
  &__content {
    ${tw`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl p-6 shadow-2xl outline-none`}
    width: min(380px, 90vw);
    max-height: 75vh;
    overflow-y: auto;
  }
`;
const CloseBtn = tw.button`absolute right-4 top-4 text-gray-400 hover:text-primary-500 transition-colors`;
const LogoImage = tw.img`h-10 mx-auto mb-3`;
const ModalHeading = tw.h2`text-xl font-extrabold text-center mb-4`;
const Item = tw.button`w-full text-left px-4 py-2 rounded-lg hover:bg-gray-100 text-sm text-gray-700 transition-colors`;

const ContentsDialog = ({ open, handleClose, contents, onSelect, render = true }) => {
  return (
    <StyledModal isOpen={open} onRequestClose={handleClose} shouldCloseOnOverlayClick={true}>
      <CloseBtn onClick={handleClose}><CloseIcon tw="w-5 h-5" /></CloseBtn>
      <LogoImage src={logo} />
      <ModalHeading>Table of Contents</ModalHeading>
      {Array.isArray(contents) && render && contents.map((content, index) => (
        <Item key={index} onClick={() => { onSelect(content.page); handleClose(); }}>
          {content.segment}
        </Item>
      ))}
    </StyledModal>
  );
};

export default ContentsDialog;
